import { ProjectConversationId, ProjectId } from 'api/models';
import { useProjectGlobalConversationQuery } from 'queries/project-global-conversation/project-global-conversation';
import { useProjectConversationContentUpdates } from './useProjectConversationContentUpdates';

export const useProjectConversationTotalUnreadCount = (
  projectId: ProjectId,
  activeConversationId?: ProjectConversationId,
): number => {
  const convItemUpdates = useProjectConversationContentUpdates(
    projectId,
    activeConversationId,
  );
  const { data: globalConversationUnread } = useProjectGlobalConversationQuery(
    projectId,
    {
      select: (result) =>
        result.conversations.filter((convo) => convo.unreadMessages).length,
    },
  );
  const count = Object.values(convItemUpdates).filter(
    (convo) => convo.unreadCount,
  ).length;

  return count + (globalConversationUnread || 0);
};
